module.exports = __webpack_public_path__ + "img/itx-file-type-mkv.0e9a352c.svg";